export default __webpack_public_path__ + "static/media/gitlab.9ffaa26e.svg";